<div class="modal-header">
  <div class="d-flex align-items-center gap-2">
    <h5 class="modal-title">
      <i class="fas fa-book"></i><ng-container>&nbsp;</ng-container><ng-container i18n>Data Dictionary</ng-container>
    </h5>
    <app-page-help [articleId]="'u3vvzsn2a4'" videoId="-"></app-page-help>
  </div>
  <button (click)="close()" type="button" class="close">
    <i class="far fa-times"></i>
  </button>
</div>
<div class="modal-body">
  <mat-tab-group [color]="'accent'">
    <mat-tab i18n-label label="Guests">
      <div class="row no-margin">
        <div *ngFor="let guest of dictionary.guest" class="col-sm-4 text-left">
          <button
            [matTooltip]="guest.tooltip"
            matTooltipPosition="above"
            (click)="addTag(guest.value)"
            type="button"
            class="data-item"
          >
            {{ guest.value }}
          </button>
        </div>
      </div>
    </mat-tab>
    <mat-tab i18n-label label="Inquiries">
      <div class="row no-margin">
        <div *ngFor="let inquiry of dictionary.inquiry" class="col-sm-4 text-left">
          <button
            [matTooltip]="inquiry.tooltip"
            matTooltipPosition="above"
            (click)="addTag(inquiry.value)"
            type="button"
            class="data-item"
          >
            {{ inquiry.value }}
          </button>
        </div>
      </div>
    </mat-tab>
    <mat-tab i18n-label label="Rentals">
      <div class="row no-margin">
        <div *ngFor="let rental of dictionary.rental" class="col-sm-4 text-left">
          <button
            [matTooltip]="rental.tooltip"
            matTooltipPosition="above"
            (click)="addTag(rental.value)"
            type="button"
            class="data-item"
          >
            {{ rental.value }}
          </button>
        </div>
      </div>
    </mat-tab>
    <mat-tab i18n-label label="Devices">
      <div class="row no-margin">
        <div *ngFor="let item of dictionary.device" class="col-sm-4 text-left">
          <button
            [matTooltip]="item.tooltip"
            matTooltipPosition="above"
            (click)="addTag(item.value)"
            type="button"
            class="data-item"
          >
            {{ item.value }}
          </button>
        </div>
      </div>
    </mat-tab>
    <mat-tab *ngIf="hasBranding" i18n-label label="Branding">
      <div class="row no-margin">
        <div *ngFor="let code of invoiceTags" class="col-sm-4 text-left">
          <button (click)="addTag(code.key)" type="button" class="data-item">{{ code.key }}</button>
        </div>
      </div>
    </mat-tab>
    <mat-tab i18n-label label="Custom">
      <div class="row no-margin">
        <div *ngFor="let code of custom$ | async" class="col-sm-4 text-left">
          <button (click)="addTag(code)" type="button" [matTooltip]="code" class="data-item">{{ code }}</button>
        </div>

        <div *ngFor="let item of attrs$ | async" class="col-sm-4 text-left">
          <button
            (click)="addTag(item.token)"
            type="button"
            [matTooltip]="item.description || item.token"
            class="data-item"
          >
            {{ item.token }}
          </button>
        </div>
      </div>
    </mat-tab>
    <mat-tab i18n-label label="Discounts">
      <div class="row no-margin">
        <div *ngFor="let item of dictionary.discount" class="col-sm-4 text-left">
          <button
            [matTooltip]="item.tooltip"
            matTooltipPosition="above"
            (click)="addTag(item.value)"
            type="button"
            class="data-item"
          >
            {{ item.value }}
          </button>
        </div>
      </div>
    </mat-tab>
    <mat-tab label="Hold Event">
      <div class="row no-margin">
        <div *ngFor="let item of dictionary.hold" class="col-sm-4 text-left">
          <button
            [matTooltip]="item.tooltip"
            matTooltipPosition="above"
            (click)="addTag(item.value)"
            type="button"
            class="data-item"
          >
            {{ item.value }}
          </button>
        </div>
      </div>
    </mat-tab>
    <mat-tab i18n-label label="Security Deposits">
      <div class="row no-margin">
        <div *ngFor="let item of dictionary.securityDeposit" class="col-sm-4 text-left">
          <button
            [matTooltip]="item.tooltip"
            matTooltipPosition="above"
            (click)="addTag(item.value)"
            type="button"
            class="data-item"
          >
            {{ item.value }}
          </button>
        </div>
      </div>
    </mat-tab>
  </mat-tab-group>
</div>
